import { render, staticRenderFns } from "./FormFiveStarsRating.vue?vue&type=template&id=510c84fe&scoped=true&"
import script from "./FormFiveStarsRating.vue?vue&type=script&lang=js&"
export * from "./FormFiveStarsRating.vue?vue&type=script&lang=js&"
import style0 from "./FormFiveStarsRating.vue?vue&type=style&index=0&id=510c84fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c84fe",
  null
  
)

export default component.exports